import React from 'react';
import clsx from 'clsx';
import {formatPatent} from "presentation/common";
import {FileDetails} from "presentation/document-detail/views/desktop/file-details";
import {DocumentsList} from "presentation/document-detail/views/mobile/documents-list";

import styles from './styles.module.scss';

export const TabletView = ({ detailInfo, documents }) => {
  return (
    <div className="flex flex-col h-full w-full overflow-hidden p-4">
      <div className="pb-2 flex justify-between items-center">
        <p className="text-primary text-lg">
          {`Vehículo: ${formatPatent(detailInfo?.vehiculo?.patente) || '-'}`}
        </p>
      </div>
      <main className={clsx('h-full w-full flex-1 flex-auto grid gap-3', styles.body)}>
        <FileDetails detailInfo={detailInfo} />
        <div className="flex flex-col w-full h-full min-h-0">
          <div className="p-4 bg-gray-50 flex justify-between items-center uppercase">
            DOCUMENTOS ({documents?.length || 0})
          </div>
          <DocumentsList className={styles.documents} documents={documents} />
        </div>
      </main>
    </div>
  );
};
